import apiClient from "../../axios/apiClient";

export const getFareList =
  (token, limit = 10, page = 1, search = "", sort = "desc") =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_FARE_LIST_PENDING" });

      const response = await apiClient.get(
        `/api/v1/fare-master`,
        {
          params: {
            limit: limit,
            page: page,
            search: search,
            sort: sort,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_FARE_LIST_FULFILLED",
        payload: response.data?.data,
        fareCount: response.data?.count,
        permissions: response.data?.permissions,
      });
    } catch (error) {
      dispatch({
        type: "GET_FARE_LIST_REJECTED",
        payload: error.response,
      });
    }
  };


  export const saveFareData = (token, data) => async (dispatch) => {
    try {
      dispatch({ type: "ADD_FARE_PENDING" });
  
      const response = await apiClient.post(
        `/api/v1/fare-master`,
        data, // Data payload should be the second argument
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({ type: "ADD_FARE_FULFILLED", payload: response.data });
    } catch (error) {
      dispatch({ type: "ADD_FARE_REJECTED", payload: error.response });
    }
  };
  

  export const getFareListById =(token,id) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_FARE_LISTBYID_PENDING" });

      const response = await apiClient.get(
        `/api/v1/fare-master/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_FARE_LISTBYID_FULFILLED",
        payload: response.data?.data,
        fareCount: response.data?.count,
      });
    } catch (error) {
      dispatch({
        type: "GET_FARE_LISTBYID_REJECTED",
        payload: error.response,
      });
    }
  };


export const updateFareData = (token, data, id) => async (dispatch) => {
  try {
    dispatch({ type: "UPDATE_FARE_PENDING" });

    const response = await apiClient.put(
      `/api/v1/fare-master/${id}`, // Endpoint URL with vehicle ID
      data, // Data payload
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_FARE_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_FARE_REJECTED", payload: error.response });
  }
};


export const deleteFareData = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: "DELETE_FARE_PENDING" });

    const response = await apiClient.delete(
      `/api/v1/fare-master/${id}`, // Endpoint URL with vehicle ID
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "DELETE_FARE_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "DELETE_FARE_REJECTED", payload: error.response });
  }
};
